import styled from 'styled-components';
import { CSVLink } from 'react-csv';

import { InputText } from 'ui/inputs';
import { RadioList } from 'ui/radioList';
import { colors, spacing } from 'ui/theme';

import { pxToRem } from 'utils/convert';

export const StyledRadioList = styled(RadioList)`
  > :nth-child(2) span {
    color: ${colors.red100};
  }
`;

export const HiddenCSVLink = styled(CSVLink)`
  display: none;
`;

export const LabelText = styled.label`
  margin-left: ${spacing.half};
  margin-bottom: 0;
  font-size: ${pxToRem(14)};
`;

export const RadioFieldWrapper = styled.div`
  margin-bottom: ${spacing.base};
`;

export const FieldWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: ${spacing.base};
`;

export const StyledInputText = styled(InputText)`
  width: ${pxToRem(90)};

  > input {
    width: 100%;
  }
`;
